import React, { useState } from "react";
import { useSelector } from "react-redux";
import { projectEntrySelectors } from "@/store";
import DeleteButtonModal from "./DeleteButtonModal";
import { DeleteIcon } from "./DeleteIcon";

const DeleteButton = ({ projectId, labRequestId, labProcedureId, handleDelete: handleDeleteProp }) => {
  const currentSystem = useSelector(projectEntrySelectors.selectCurrentSystem);

  const [isLoading, setIsLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [forceDelete, setForceDelete] = useState(false);

  const onDelete = async () => {
    setIsLoading(true);
    try {
      if (currentSystem === "VPIN") {
        await handleDeleteProp(projectId);
      } else if (currentSystem === "LRS") {
        await handleDeleteProp(
          {
            requestId: labRequestId,
            procedures: [{ procedureId: labProcedureId }]
          }
        );
      } else {
        throw new Error(`Unknown system: ${currentSystem}`);
        return;
      }
    } catch (err) {
      throw new Error(`err`);
    } finally {
      handleClose();
    }
  };

  const handleClose = () => {
    setIsLoading(false);
    setForceDelete(false);
    setModalOpen(false);
  };

  return (
    <>
      <DeleteIcon onClick={() => setModalOpen(true)} />

      <DeleteButtonModal
        isLoading={isLoading}
        isOpen={modalOpen}
        onClose={handleClose}
        onSubmit={onDelete}
        forceDelete={forceDelete}
      />
    </>
  );
};

export default DeleteButton;